import { useLazyQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { loadingData } from "../..";
import { QUERY_TYPE_DOCUMENT } from "../../../Screens/typeDocuments/apollo";
export default function ListDocumentType({
  style,
  className,
  defaultValue,
  size,
  getData,
}) {
  const inputSize =
    size === "lg"
      ? "form-control-lg"
      : size === "sm"
      ? "form-control-sm"
      : "form-control-md";
  const [searchValue, setSearchValue] = useState();
  const [show, setShow] = useState(false);
  const [fetchData, { data, loading }] = useLazyQuery(QUERY_TYPE_DOCUMENT);
  useEffect(() => {
    fetchData({
      variables: {
        where: {
          title: searchValue ? searchValue : undefined,
        },
        limit: 25,
      },
    });
  }, [searchValue]);

  const handleClick = (value) => {
    if (!value && getData) {
      getData(null);
      setShow(false);
      return;
    }
    try {
      const result = data?.documentTypes?.data?.filter(
        (obj) => obj?.title === value
      );
      if (result.length > 0 && getData) {
        getData(result[0]);
        setShow(false);
      }
    } catch (error) {
      if (getData) getData();
    }
  };

  return (
    <React.Fragment>
      <input
        type={"button"}
        className={`form-control text-left ${inputSize} ${className}`}
        style={{ textAlign: "left" }}
        value={defaultValue ? defaultValue : "ໝວດເອກະສານ"}
        onClick={() => setShow(true)}
      />
      <Modal
        show={show}
        centered
        style={style}
        className={className}
        onHide={() => setShow(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-5">ເລືອກໝວດ</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custom-modal-body">
          <div className="form-group mb-2">
            <input
              type={"search"}
              className="form-control form-control-lg"
              onChange={(e) => setSearchValue(e.target.value)}
              onInput={(e) => {
                if (!e.target.value && getData) getData();
              }}
              placeholder="ຄົ້ນຫາ"
            />
          </div>
          {loading ? (
            <center>{loadingData(25, "ກຳລັງໂຫຼດຂໍ້ມູນ...")}</center>
          ) : (
            <div className="mt-1 ">
              <div
                className="py-2 border-bottom"
                onClick={() => handleClick("")}
              >
                <span>
                  <i className="fa fa-map-marker-alt text-danger mr-3" />{" "}
                  ເລືອກໝວດ
                </span>
              </div>

              {data?.documentTypes?.data?.map((data, index) => (
                <div
                  className="d-flex py-2 border-bottom"
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleClick(data?.title)}
                >
                  <span className="text-black">
                    {" "}
                    <i className="fa fa-map-marker-alt text-danger mr-2" />{" "}
                    {data?.title}
                  </span>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
